import request from "@/utils/request";

/**
 * 获取游客融云帐号
 *
 * @description 获取游客融云帐号
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function registerRongYunAccount(playload) {
  return request({
    url: "/api/v2/chat/registerRongYunAccount",
    method: "POST",
    data: playload,
    noEncrypt: true
  });
}
/**
 * 聊天室禁言
 *
 * @description 聊天室禁言
 *
 * @see 无接口文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function banUserSpeak(playload) {
  return request({
    url: "/api/v2/chat/banUserSpeak",
    method: "POST",
    data: playload,
    userId: true
  });
}
/**
 * 查询聊天室总人数
 *
 * @description 查询聊天室总人数
 *
 * @see 无接口文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryChatPeopleCount(playload) {
  return request({
    url: "/api/v2/chat/queryChatPeopleCount",
    method: "POST",
    data: playload,
    noEncrypt: true
  });
}
/**
 * 获取视频下载地址列表
 *
 * @description 获取视频下载地址列表
 *
 * @see 无接口文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function getLotChatVideoList(playload, config) {
  return request({
    url: "/api/v2/chat/getLotChatVideoList",
    method: "POST",
    data: playload,
    ...config,
    noEncrypt: true
  });
}

/**
 * 190.查询聊天室房间列表
 *
 * @description 190.查询聊天室房间列表
 *
 * @see 无接口文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryChatRooms(playload, config) {
  return request({
    url: "/api/v2/chat/queryChatRooms",
    method: "POST",
    data: playload,
    noEncrypt: true,
    ...config
  });
}

/**
 * 获取视频下载地址列表
 *
 * @description 验证房间密码（加密）
 *
 * @see 无接口文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function checkChatRoomPassword(playload, config) {
  return request({
    url: "/api/v2/chat/checkChatRoomPassword",
    method: "POST",
    data: playload,
    ...config
  });
}

/**
 * 192.查询聊天室房间下拉列表
 *
 * @description 验证房间密码（加密）
 *
 * @see 无接口文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryChatRoomComboBox(playload, config) {
  return request({
    url: "/api/v2/chat/queryChatRoomComboBox",
    method: "POST",
    data: playload,
    noEncrypt: true,
    ...config
  });
}

/**
 * 192.查询聊天室房间下拉列表
 *
 * @description 验证房间密码（加密）
 *
 * @see 无接口文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryCheckChatRoomPwd(playload, config) {
  return request({
    url: "/api/v2/chat/queryCheckChatRoomPwd",
    method: "POST",
    data: playload,
    noEncrypt: true,
    ...config
  });
}

/**
 * 194.查询聊天室客服列表
 */
export async function queryChatCustComerService(playload, config) {
  return request({
    url: "/api/v2/chat/queryChatCustComerService",
    method: "POST",
    data: playload,
    noEncrypt: true,
    ...config
  });
}

/**
 * 195查询聊天室真实人员列表
 */
export async function queryChatPersons(playload, config) {
  return request({
    url: "/api/v2/chat/queryChatPersons",
    method: "POST",
    data: playload,
    noEncrypt: true,
    ...config
  });
}

/**
 * 查询是否为管理员
 * （用于不经过聊天室，进到私聊房间的情况）
 */
export async function queryCurrUserIsAdmin(playload, config) {
  return request({
    url: "/api/v2/chat/queryChatAdmin",
    method: "POST",
    data: playload,
    noEncrypt: true,
    ...config
  });
}

/**
 *
 * @description .查询可分享的聊天室列表
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */

export async function queryShareChatRoom(playload, config) {
  return request({
    url: "/api/v2/betShare/getLotteryChatRooms",
    method: "POST",
    data: playload,
    noEncrypt: true,
    ...config
  });
}

/**
 *
 * @description 203.	炫耀今日战绩
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */

export async function shareTodayBetWin(playload, config) {
  return request({
    url: "/api/v2/betShare/shareTodayBetWin",
    method: "POST",
    data: playload,
    ...config
  });
}

/**
 *
 * @description 203.	分享单个注单
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */

export async function shareSingleBet(playload, config) {
  return request({
    url: "/api/v2/betShare/shareRecord",
    method: "POST",
    data: playload,
    ...config
  });
}
